export const GET_SOUND_CATEGORY="GET_SOUND_CATEGORY"
export const SOUND_CATEGORY_ADD="SOUND_CATEGORY_ADD"
export const SOUND_CATEGORY_EDIT="SOUND_CATEGORY_EDIT"
export const SOUND_CATEGORY_DELETE="SOUND_CATEGORY_DELETE"

export const GET_SOUND_LIST="GET_SOUND_LIST"
export const SOUND_LIST_ADD="SOUND_LIST_ADD"
export const SOUND_LIST_EDIT="SOUND_LIST_EDIT"
export const SOUND_LIST_DELETE="SOUND_LIST_DELETE"